import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  GET_ALL: 'VIBE_GET_ALL',
  GET_ALL_SUCCESS: 'VIBE_GET_ALL_SUCCESS',
  GET_ALL_FAILURE: 'VIBE_GET_ALL_FAILURE',
  POST: 'VIBE_POST',
  POST_SUCCESS: 'VIBE_POST_SUCCESS',
  POST_FAILURE: 'VIBE_POST_FAILURE',
  PATCH: 'VIBE_PATCH',
  PATCH_SUCCESS: 'VIBE_PATCH_SUCCESS',
  PATCH_FAILURE: 'VIBE_PATCH_FAILURE',
  INVALIDATE_LIST: 'VIBE_INVALIDATE_LIST',
};

const URL = `${BASE_URL}/inapp-notification/vibe/`;

export const getAll = actions.getAll(() => URL, {
  PENDING: ACTIONS.GET_ALL,
  SUCCESS: ACTIONS.GET_ALL_SUCCESS,
  FAILURE: ACTIONS.GET_ALL_FAILURE,
});

export const post = actions.post(() => URL, {
  PENDING: ACTIONS.POST,
  SUCCESS: ACTIONS.POST_SUCCESS,
  FAILURE: ACTIONS.POST_FAILURE,
});

export const patch = actions.patch(id => `${URL}${id}`, {
  PENDING: ACTIONS.PATCH,
  SUCCESS: ACTIONS.PATCH_SUCCESS,
  FAILURE: ACTIONS.PATCH_FAILURE,
});
